import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/campos_adicionais${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/atendimento/campos_adicionais', data)
  },
  edit(data) {
    return axios.put(`/atendimento/campos_adicionais/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/atendimento/campos_adicionais/${id}`)
  },
}
